import type { TOC } from '@ember/component/template-only';
import { PrismIcon, PrismTooltipHeader } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import HotelMarketInsightTooltipsTooltipBlockSearches from 'lumen/components/hotel/market-insight/tooltips/tooltip-block-searches';

interface HotelMarketInsightTooltipsTooltipSearchesSignature {
  Args: {
    searchSummary: unknown;
    tooltipTitle: unknown;
  };
}

const HotelMarketInsightTooltipsTooltipSearches = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <PrismTooltipHeader>
    {{@tooltipTitle}}
  </PrismTooltipHeader>
  <div class="tooltip__content">
    <HotelMarketInsightTooltipsTooltipBlockSearches
      @searchSummary={{@searchSummary}}
    />
  </div>
  {{#if @searchSummary.isSummaryIncomplete}}
    <div class="tooltip__footer">
      <div class="flex justify-start">
        <PrismIcon @color="warning" @name="warning" @size="small" />
        <p class="warning-message paragraph-200--regular ml-100">{{t
            "market_insight.warning.incomplete_week"
          }}</p>
      </div>
    </div>
  {{/if}}
</template> satisfies TOC<HotelMarketInsightTooltipsTooltipSearchesSignature>;

export default HotelMarketInsightTooltipsTooltipSearches;
